module.exports = __webpack_public_path__ + "static/sequence_card-b89f15ecb7693268b428ac94bd3285d8.png";